var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgQuestionMark = _ref => {
  let {
    svgRef,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.69844 8.19844H6.29844V8.09484C6.29844 7.48164 6.51264 7.04554 6.99844 6.79844C7.26794 6.66194 7.69844 6.40084 7.69844 6.09844C7.69844 5.71274 7.38484 5.39844 6.99844 5.39844C6.61204 5.39844 6.29844 5.71274 6.29844 6.09844H4.89844C4.89844 4.94064 5.84064 3.99844 6.99844 3.99844C8.15624 3.99844 9.09844 4.69844 9.09844 6.09844C9.09844 7.49844 7.69844 7.61394 7.69844 8.19844ZM6.29844 10.9984H7.69844V9.59844H6.29844V10.9984ZM6.99844 1.89844C3.90584 1.89844 1.39844 4.40584 1.39844 7.49844C1.39844 10.591 3.90584 13.0984 6.99844 13.0984C10.091 13.0984 12.5984 10.591 12.5984 7.49844C12.5984 4.40584 10.091 1.89844 6.99844 1.89844Z",
    fill: "#5C5F62"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgQuestionMark, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/question-mark.10f781bd.svg";
export { ForwardRef as ReactComponent };